"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentResponseToJSON = exports.AttachmentResponseFromJSONTyped = exports.AttachmentResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AttachmentResponseFromJSON(json) {
    return AttachmentResponseFromJSONTyped(json, false);
}
exports.AttachmentResponseFromJSON = AttachmentResponseFromJSON;
function AttachmentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'attachment': _1.AttachmentModelFromJSON(json['attachment']),
        'hasBackSide': json['hasBackSide'],
        'fields': !runtime_1.exists(json, 'fields') ? undefined : (json['fields'].map(_1.FieldModelFromJSON)),
        'required': !runtime_1.exists(json, 'required') ? undefined : _1.AttachmentResponseRequiredFromJSON(json['required']),
        'documentReviewNotes': !runtime_1.exists(json, 'documentReviewNotes') ? undefined : json['documentReviewNotes'],
    };
}
exports.AttachmentResponseFromJSONTyped = AttachmentResponseFromJSONTyped;
function AttachmentResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'attachment': _1.AttachmentModelToJSON(value.attachment),
        'hasBackSide': value.hasBackSide,
        'fields': value.fields === undefined ? undefined : (value.fields.map(_1.FieldModelToJSON)),
        'required': _1.AttachmentResponseRequiredToJSON(value.required),
        'documentReviewNotes': value.documentReviewNotes,
    };
}
exports.AttachmentResponseToJSON = AttachmentResponseToJSON;
//# sourceMappingURL=AttachmentResponse.js.map